var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 18.25H0.9375C0.390625 18.25 0 17.8594 0 17.3125C0 16.8047 0.390625 16.375 0.9375 16.375H14.0625C14.5703 16.375 15 16.8047 15 17.3125C15 17.8594 14.5703 18.25 14.0625 18.25ZM6.79688 12.9766L1.79688 7.66406C1.44531 7.27344 1.48438 6.6875 1.83594 6.33594C2.22656 5.98438 2.8125 5.98438 3.16406 6.375L6.5625 9.96875V6.6875V1.6875C6.5625 1.17969 6.95312 0.75 7.5 0.75C8.00781 0.75 8.4375 1.17969 8.4375 1.6875V6.6875V9.96875L11.7969 6.375C12.1484 5.98438 12.7344 5.98438 13.125 6.33594C13.5156 6.6875 13.5156 7.27344 13.1641 7.66406L8.16406 12.9766C7.96875 13.1719 7.73438 13.25 7.5 13.25C7.22656 13.25 6.99219 13.1719 6.79688 12.9766Z",
    fill: "#031621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1877deafbaafd2172a48232fdeb07e31.svg";
export { ForwardRef as ReactComponent };